import AppHeader from '../AppHeader'
import DayJs from 'dayjs'

export default {
  name: 'es-mycard-result',
  created () {
    this.shopGet()
    if (!this.isSystemManagement && !this.isHumanStaff) {
      this.humanOutCondition = 'shop'
      this.cardOutCondition = 'shop'
      this.humanOutShopId = window.localStorage.getItem('shop_id')
      this.cardOutShopId = window.localStorage.getItem('shop_id')
    }
  },
  data () {
    return {
      startDate: '',
      endDate: '',
      humanOutCondition: 'all',
      humanOutShopId: '',
      cardOutCondition: 'all',
      cardOutShopId: '',
      shopGetCallbackFlag: false,
      canValidate: true
    }
  },
  computed: {
    shops () {
      let shops = this.$store.getters.shopsAll
      if (!this.isSystemManagement && !this.isHumanStaff) {
        shops = shops.filter(shop => shop.id ===  window.localStorage.getItem('shop_id'))
      }
      return shops
    },
    validation: function () {
      var v = {
        integrity: !!this.startDate && !!this.endDate &&
                   this.startDate > this.endDate,
        not_input: !!this.startDate && !!this.endDate &&
                   this.startDate <= this.endDate
      }
      if (!this.canValidate) {
        Object.keys(v).forEach(key => { v[key] = true })
      }
      return v
    },
    isValid () {
      var validation = this.validation
      return Object.keys(validation).every(function (key) {
        return validation[key]
      })
    },
    isSystemManagement () {
      return this.$store.getters.isSystemManagement
    },
    isHumanStaff () {
      return window.localStorage.getItem('is_human_staff') === '1'
    },
    canExportEsMycard () {
      return window.localStorage.getItem('can_export_es_mycard') === '1'
    }
  },
  components: {
    AppHeader
  },
  methods: {
    shopGet: function () {
      var self = this
      var callback = function () {
        self.shopGetCallbackFlag = true
        //退職者一覧店舗を表示しない
        var workIndex = 0
        for (var i = 0; i < self.shops.length; i++) {
          if (self.shops[i].id == 800) {
            workIndex = i
            break
          }
        }
        if (workIndex != 0) {
          self.shops.splice(workIndex, 1)
        }
      }

      this.$store.dispatch('SHOP_ALL_GET', {callback: callback})
    },
    async humanDataDownload () {
      let data = {
        start_date: DayJs(this.startDate).format('YYYY-MM-DD'),
        end_date: DayJs(this.endDate).format('YYYY-MM-DD'),
        human_out_shop_id: this.humanOutCondition === 'all' ? null: this.humanOutShopId
      }
      
      let res = await this.$store.dispatch('ES_MYCARD_HUMAN_CSV', { data: data })
      .catch(err => {
        console.log(err)
        return
      })
      this.onHumanDownloadCsv(res.csv_data)
    },
    onHumanDownloadCsv: function(data) {
      let wkFileName = DayJs(this.startDate).format('YYYYMMDD') + '-' + DayJs(this.endDate).format('YYYYMMDD') + '_'
      if (this.humanOutCondition === 'all') {
        wkFileName += '全店舗_'
      }else{
        const shop = this.shops.filter(item => item.id === this.humanOutShopId)
        wkFileName += `${shop[0].attributes['shop-name']}_`
      }
      wkFileName += '(人単位)ESmyカード.csv'
      const csvFileName = wkFileName
      let bom = new Uint8Array([0xef, 0xbb, 0xbf])
      let mimeType = 'text/csv'
      let csv = '店舗名,役職,社員名,渡した枚数,もらった枚数,いいね押した数,いいね押された数\n'
      data.forEach(obj => {
        if (obj.shop_name) {
          csv += this.enquoteForCSV(obj.shop_name) + ','
        } else {
          csv += ','
        }
        if (obj.user_type_name) {
          csv += this.enquoteForCSV(obj.user_type_name) + ','
        } else {
          csv += ','
        }
        if (obj.user_name) {
          csv += this.enquoteForCSV(obj.user_name) + ','
        } else {
          csv += ','
        }
        if (obj.give_count) {
          csv += this.enquoteForCSV(obj.give_count) + ','
        } else {
          csv += '0,'
        }
        if (obj.get_count) {
          csv += this.enquoteForCSV(obj.get_count) + ','
        } else {
          csv += '0,'
        }
        if (obj.give_like_count) {
          csv += this.enquoteForCSV(obj.give_like_count) + ','
        } else {
          csv += '0,'
        }
        if (obj.get_like_count) {
          csv += this.enquoteForCSV(obj.get_like_count)
        } else {
          csv += '0'
        }
        csv += '\n'
      })
      const blob = new Blob([bom, csv], { type: mimeType })
      let hiddenElement = document.createElement('a')
      hiddenElement.download = csvFileName
      hiddenElement.target = '_blank'
      if (window.navigator.msSaveBlob) {
        window.navigator.msSaveBlob(blob, csvFileName)
      } else if (window.URL && window.URL.createObjectURL){
        hiddenElement.href = window.URL.createObjectURL(blob)
        document.body.appendChild(hiddenElement)
        hiddenElement.click()
        document.body.removeChild(hiddenElement)
      } else if (window.webkitURL && window.webkitURL.createObject) {
        hiddenElement.href = (window.URL || window.webkitURL).createObjectURL(blob)
        hiddenElement.click()
      }
    },
    async cardDataDownload () {
      let data = {
        start_date: DayJs(this.startDate).format('YYYY-MM-DD'),
        end_date: DayJs(this.endDate).format('YYYY-MM-DD'),
        card_out_shop_id: this.cardOutCondition === 'all' ? null: this.cardOutShopId
      }
      let res = await this.$store.dispatch('ES_MYCARD_CARD_CSV', { data: data })
      .catch(err => {
        console.log(err)
        return
      })
      this.onCardDownloadCsv(res.csv_data)
    },
    onCardDownloadCsv: function(data) {
      let wkFileName = DayJs(this.startDate).format('YYYYMMDD') + '-' + DayJs(this.endDate).format('YYYYMMDD') + '_'
      if (this.cardOutCondition === 'all') {
        wkFileName += '全店舗_'
      }else{
        const shop = this.shops.filter(item => item.id === this.cardOutShopId)
        wkFileName += `${shop[0].attributes['shop-name']}_`
      }
      wkFileName += '(カード単位)ESmyカード.csv'
      const csvFileName = wkFileName
      let bom = new Uint8Array([0xef, 0xbb, 0xbf])
      let mimeType = 'text/csv'
      let csv = '作成日時,渡した社員の店舗名,渡した社員の役職名,渡した社員名,もらった社員の店舗名,もらった社員の役職名,もらった社員名,いいね数,カード内容,安心,誠実,感動,快適,創造,礼節,想像,感応,表現,挑夢,通報者の所属店舗,問題報告した社員名,問題報告理由,削除者の所属店舗,削除した社員名\n'
      data.forEach(obj => {
        if (obj.created_at) {
          csv += this.enquoteForCSV(obj.created_at) + ','
        } else {
          csv += ','
        }
        if (obj.give_shop_name) {
          csv += this.enquoteForCSV(obj.give_shop_name) + ','
        } else {
          csv += ','
        }
        if (obj.give_user_type_name) {
          csv += this.enquoteForCSV(obj.give_user_type_name) + ','
        } else {
          csv += ','
        }
        if (obj.give_user_name) {
          csv += this.enquoteForCSV(obj.give_user_name) + ','
        } else {
          csv += ','
        }
        if (obj.get_shop_name) {
          csv += this.enquoteForCSV(obj.get_shop_name) + ','
        } else {
          csv += ','
        }
        if (obj.get_user_type_name) {
          csv += this.enquoteForCSV(obj.get_user_type_name) + ','
        } else {
          csv += ','
        }
        if (obj.get_user_name) {
          csv += this.enquoteForCSV(obj.get_user_name) + ','
        } else {
          csv += ','
        }
        if (obj.like_count) {
          csv += this.enquoteForCSV(obj.like_count) + ','
        } else {
          csv += '0,'
        }
        if (obj.comments) {
          csv += this.enquoteForCSV(obj.comments) + ','
        } else {
          csv += ','
        }
        if (obj.idea_peace_ming) {
          csv += this.enquoteForCSV(obj.idea_peace_ming) + ','
        } else {
          csv += '0,'
        }
        if (obj.idea_sincere) {
          csv += this.enquoteForCSV(obj.idea_sincere) + ','
        } else {
          csv += '0,'
        }
        if (obj.idea_excitement) {
          csv += this.enquoteForCSV(obj.idea_excitement) + ','
        } else {
          csv += '0,'
        }
        if (obj.idea_comfortable) {
          csv += this.enquoteForCSV(obj.idea_comfortable) + ','
        } else {
          csv += '0,'
        }
        if (obj.idea_creation) {
          csv += this.enquoteForCSV(obj.idea_creation) + ','
        } else {
          csv += '0,'
        }
        if (obj.idea_civility) {
          csv += this.enquoteForCSV(obj.idea_civility) + ','
        } else {
          csv += '0,'
        }
        if (obj.idea_imagination) {
          csv += this.enquoteForCSV(obj.idea_imagination) + ','
        } else {
          csv += '0,'
        }
        if (obj.idea_sympathy) {
          csv += this.enquoteForCSV(obj.idea_sympathy) + ','
        } else {
          csv += '0,'
        }
        if (obj.idea_expression) {
          csv += this.enquoteForCSV(obj.idea_expression) + ','
        } else {
          csv += '0,'
        }
        if (obj.idea_challenge_dream) {
          csv += this.enquoteForCSV(obj.idea_challenge_dream) + ','
        } else {
          csv += '0,'
        }
        if (obj.problem_report_user_shop_name) {
          csv += this.enquoteForCSV(obj.problem_report_user_shop_name) + ','
        } else {
          csv += ','
        }
        if (obj.problem_report_user_name) {
          csv += this.enquoteForCSV(obj.problem_report_user_name) + ','
        } else {
          csv += ','
        }
        if (obj.problem_report_reason) {
          csv += this.enquoteForCSV(obj.problem_report_reason) + ','
        } else {
          csv += ','
        }
        if (obj.deleted_user_shop_name) {
          csv += this.enquoteForCSV(obj.deleted_user_shop_name) + ','
        } else {
          csv += ','
        }
        if (obj.deleted_user_name) {
          csv += this.enquoteForCSV(obj.deleted_user_name)
        }
        csv += '\n'
      })
      const blob = new Blob([bom, csv], { type: mimeType })
      let hiddenElement = document.createElement('a')
      hiddenElement.download = csvFileName
      hiddenElement.target = '_blank'
      if (window.navigator.msSaveBlob) {
        window.navigator.msSaveBlob(blob, csvFileName)
      } else if (window.URL && window.URL.createObjectURL){
        hiddenElement.href = window.URL.createObjectURL(blob)
        document.body.appendChild(hiddenElement)
        hiddenElement.click()
        document.body.removeChild(hiddenElement)
      } else if (window.webkitURL && window.webkitURL.createObject) {
        hiddenElement.href = (window.URL || window.webkitURL).createObjectURL(blob)
        hiddenElement.click()
      }
    },
    enquoteForCSV: function (val) {
      if (!val) return val
      if (/[",\r\n]/.test(val)) { //",\r\nが含まれる場合はenquoteする
        val = '"' + val.replace(/"/g, '""') + '"'
      }
      return val
    },
    onClickCancel () {
      this.$router.push({ path: '/' })
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/es-mycard-result.js